export class FontListingDTO {
    id: number;
    name: string;
    file: string;
}